import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import constants from "../constants/constants";
import { useLocation } from "react-router-dom";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useState, useRef } from "react";
import SEO, { pageSEO } from "../components/seo.component";
import { useUserParams } from "../hooks/useUserParams";

export default function About() {
  const {
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentAbout,
    getCurrentHeadshot
  } = useUserParams();
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [animationState, setAnimationState] = useState({
    topBorder: false,
    sideBorders: false,
    bottomBorder: false,
  });

  // Create refs for border elements
  const topLeftRef = useRef(null);
  const topRightRef = useRef(null);
  const bottomLeftRef = useRef(null);
  const bottomRightRef = useRef(null);
  const rightRef = useRef(null);
  const leftRef = useRef(null);

  const onWindowResize = () => {
    setWindowSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", onWindowResize);
    return () => {
      window.removeEventListener("resize", onWindowResize);
    };
  }, []);

  useEffect(() => {
    // Trigger animations in sequence
    const animationSequence = async () => {
      // Top borders
      setAnimationState((prev) => ({ ...prev, topBorder: true }));

      // Side borders
      setTimeout(() => {
        setAnimationState((prev) => ({ ...prev, sideBorders: true }));
      }, 1000);

      // Bottom borders
      setTimeout(() => {
        setAnimationState((prev) => ({ ...prev, bottomBorder: true }));
      }, 4000);
    };

    animationSequence();
  }, []);

  function isScrolledIntoView(elem) {
    if (elem) {
      var rect = elem.getBoundingClientRect();
      var elemTop = rect.top;
      var elemBottom = rect.bottom;

      var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight;

      return isVisible;
    }
  }

  const seoConfig = pageSEO.about();

  return (
    <>
      <SEO {...seoConfig} />
      <div className="max-w-[1100px] mx-auto gap-x-24 gap-y-10 px-6 grid sm:grid-cols-2 min-h-[70vh] pt-[150px] min-[1100px]:pt-[200px] mb-[100px]">
        <div className="relative self-start">
          {windowSize > 1200 ? (
            <div className="absolute h-[510px] w-[120%] bottom-[-30px] left-[-10%] -z-10">
              <div
                ref={topRightRef}
                className={`g-right absolute left-[50%] h-[2px] duration-1000 ${
                  animationState.topBorder ? "w-half" : "w-0"
                }`}
              ></div>
              <div
                ref={topLeftRef}
                className={`g-left absolute right-[50%] h-[2px] duration-1000 ${
                  animationState.topBorder ? "w-half" : "w-0"
                }`}
              ></div>
              <div
                ref={leftRef}
                className={`bg-[#81817f] absolute w-[2px] left-0 duration-3000 ${
                  animationState.sideBorders ? "h-full" : "h-0"
                }`}
              ></div>
              <div
                ref={rightRef}
                className={`bg-[#5e658a] absolute w-[2px] right-0 duration-3000 ${
                  animationState.sideBorders ? "h-full" : "h-0"
                }`}
              ></div>
              <div
                ref={bottomRightRef}
                className={`g-right absolute bottom-0 right-0 h-[2px] duration-1000 ${
                  animationState.bottomBorder ? "w-half" : "w-0"
                }`}
              ></div>
              <div
                ref={bottomLeftRef}
                className={`g-left absolute bottom-0 left-0 h-[2px] duration-1000 ${
                  animationState.bottomBorder ? "w-half" : "w-0"
                }`}
              ></div>
            </div>
          ) : null}
          <img
            src={getCurrentHeadshot()}
            className="w-full"
            alt={getCurrentAgentName()}
          />
          <div className="flex flex-col gap-y-2 text-black mt-6">
            <h2 className="text-black libre text-3xl">
              {getCurrentAgentName()}
            </h2>
            <p className="italic text-lg">
              {getCurrentAgentTitle()}, {getCurrentBrokerage()}
            </p>

            <div className="flex gap-x-5 my-2">
              {Object.entries(constants.SOCIALS ?? {})
                .filter(([key, val]) => val.length > 0)
                .map(([k, v]) => (
                  <a
                    key={k}
                    href={constants.SOCIALS[k]}
                    aria-label={`${k} social link`}
                >
                  <FontAwesomeIcon
                    className="fa-xl text-logo-third"
                    icon={constants.ICONS[k]}
                  />
                </a>
              ))}
            </div>
            <p className="font-semibold text-lg">
              <FontAwesomeIcon
                icon={faPhone}
                className="pr-2 text-logo-third"
              />
              {getCurrentAgentNumber()}
            </p>
            <p className="text-lg">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="pr-2 text-logo-third"
              />
              {getCurrentAgentEmail()}
            </p>
          </div>
        </div>
        <div>
          <h1
            className={`text-4xl text-black pb-8 libre duration-2000 slide-in ${
              windowSize > 700 ? "slide-left" : ""
            }`}
          >
            About Me
          </h1>

          {getCurrentAbout() ? (
            getCurrentAbout().split("<|>").map((p, index) => (
              <p key={index}>
                {p}
                <br />
                <br />
              </p>
            ))
          ) : (
            <p>Coming Soon</p>
          )}
        </div>
      </div>
    </>
  );
}
